import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SectionTemplate as SchemaSectionTemplate } from '../schemas/SectionTemplate';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SectionTemplate
 */
export const GetSectionTemplatesContentType = '' as const;
export type GetSectionTemplatesRequest = void;
export type GetSectionTemplatesResponses = LinkCommonErrorResponses & {
    /**
     * @description List of section templates
     */
    '200': {
        'application/json': SchemaSectionTemplate[];
    };
};
export type GetSectionTemplatesResponseSuccess = GetSectionTemplatesResponses['200']['application/json'];
export type GetSectionTemplatesSearchParams = undefined;
export type GetSectionTemplatesPathParameters = undefined;
export const GetSectionTemplatesUrl = '/section_template' as const;
export const GetSectionTemplatesMethod = 'GET' as const;
export const getGetSectionTemplatesUrl = (_params?: GetSectionTemplatesPathParameters) => GetSectionTemplatesUrl;
